import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "project-map",
      path: "project-map",
      meta: { icon: "map", title: i18n.global.t("Project Map") },
      component: () => import("pages/employee/ProjectMap"),
    },
    {
      name: "projects",
      path: "projects",
      meta: { icon: "project", title: i18n.global.tc("Project", 100) },
      component: () => import("pages/employee/Projects"),
    },
    {
      name: "projects-archive",
      path: "projects/archive",
      meta: { icon: "project", title: i18n.global.tc("Project", 100) },
      component: () => import("pages/employee/Projects"),
    },
    {
      name: "projects-search",
      path: "projects/search/:query?",
      meta: { icon: "project", title: i18n.global.tc("Project", 100) },
      component: () => import("pages/employee/Projects"),
    },
    {
      name: "project-view",
      path: "projects/:projectID/:tab?",
      props: true,
      meta: {
        icon: (route) => {
          const project = store.state.main.projects[route.params.projectID];
          return project ? project.type.icon : "new_home";
        },
        title: (route) => route.params.projectID,
        windowTitle: (route) =>
          i18n.global.tc("Project") + " " + route.params.projectID,
        crumbs: ["projects"],
      },
      component: () => import("pages/employee/ProjectView"),
    },
    {
      name: "project-message-view",
      path: "/projects/:projectID/messages/:messageID",
      beforeEnter: async (to, from) => {
        store.dispatch("OPEN_MESSAGE", {
          projectID: to.params.projectID,
          messageID: to.params.messageID,
        });
        if (from.name) {
          return false;
        }
        return {
          name: "project-view",
          params: {
            projectID: to.params.projectID,
          },
        };
      },
    },
    {
      name: "project-edit",
      path: "projects/:projectID/edit",
      props: true,
      meta: {
        icon: "edit",
        title: i18n.global.t("Edit Project"),
        windowTitle: (route) =>
          i18n.global.t("Edit Project") + " " + route.params.projectID,
        crumbs: ["projects"],
      },
      component: () => import("pages/employee/ProjectEdit"),
    },
  ],

  dialogs: [
    {
      name: "task-new",
      path: "/projects/:projectID/tasks/new",
      meta: {
        icon: "task",
        title: i18n.global.t("New Task"),
      },
      component: () => import("../../../dialogs/employee/TaskEdit"),
    },
    {
      name: "task-new-from-message",
      path: "/projects/:projectID/tasks/new/:messageID",
      meta: {
        icon: "task",
        title: i18n.global.t("New Task"),
      },
      component: () => import("../../../dialogs/employee/TaskEdit"),
    },
    {
      name: "task-new-from-notification",
      path: "/projects/:projectID/tasks/new/notification/:notificationID",
      meta: {
        icon: "task",
        title: i18n.global.t("New Task"),
      },
      component: () => import("../../../dialogs/employee/TaskEdit"),
    },
    {
      name: "task-new-from-email",
      path: "/projects/:projectID/tasks/new/email/:emailID",
      meta: {
        icon: "task",
        title: i18n.global.t("New Task"),
      },
      component: () => import("../../../dialogs/employee/TaskEdit"),
    },
    {
      name: "task-view",
      path: "/projects/:projectID/tasks/:taskID/view",
      meta: {
        icon: "task",
        title: i18n.global.tc("Task"),
      },
      component: () => import("../../../dialogs/employee/TaskView"),
    },
    {
      name: "task-edit",
      path: "/projects/:projectID/tasks/:taskID/edit",
      meta: {
        icon: "task",
        title: i18n.global.t("Edit Task"),
      },
      component: () => import("../../../dialogs/employee/TaskEdit"),
    },
    // Message topics (the messenger's topic bar and message menu)
    {
      name: "topic-new",
      path: "/projects/:projectID/topics/new",
      component: () => import("../../../dialogs/employee/TopicEdit"),
    },
    {
      name: "topic-new-for-message",
      path: "/projects/:projectID/topics/new/:messageID",
      component: () => import("../../../dialogs/employee/TopicEdit"),
    },
    {
      name: "topic-edit",
      path: "/projects/:projectID/topics/:topicID/edit",
      component: () => import("../../../dialogs/employee/TopicEdit"),
    },
    {
      name: "message-topic",
      path: "/projects/:projectID/messages/:messageID/topic",
      component: () => import("../../../dialogs/employee/MessageTopic"),
    },

    // Files tab uploads
    {
      name: "project-files-upload",
      path: "/projects/:projectID/files/upload",
      component: () => import("../../../dialogs/employee/ProjectFilesUpload"),
    },
  ],
};
